<template>
    <!--底部-->
    <footer class="gl-footer">
        <div class="footer-wrap">
            <div class="content-wrap footer-block">
                <!-- <p>指导单位：{{ setting.aboutUs }}
                    <span style="margin-left: 25px">主办单位：{{ setting.contcatUs }}</span>
                </p>
                <p>客服电话：{{ setting.copyright }}</p> -->
                <div v-html="setting && setting.footerInfo"></div>
            </div>
        </div>
    </footer>
</template>

<script>
import tool from '@/utils/tool'
export default {
    name: "mFooter",
    data() {
        return {
            setting: {
                name:'智慧服务平台',
                aboutUs: '大中专学校学生信息咨询与就业指导中心',
                contcatUs: '',
                copyright: '省教育厅信息中心',
                switch:true,//网站开关
                closeRemark:'',//关闭说明
                footerInfo:''//底部信息
            }
        }
    },
    async mounted() {
        // 清除旧缓存，重新获取
        tool.data.remove('setting');

        var res = await this.$api.getSetting();
        // res 是解包后的 data 对象，直接赋值即可
        if(res && res.switch !== undefined){
            tool.data.set('setting', res);
            console.log('res',res);
            this.setting=res;
        }else{
            Element.alert("服务端异常，请刷新后重试。");
        }
        console.log('setting',this.setting);
        if(this.setting&&this.setting.switch!=undefined&&!this.setting.switch){//网站关闭
            alert(this.setting.closeRemark)
        }
        document.title=this.setting.name;
    }
}
</script>

<style scoped>

</style>